import React, { Fragment, useEffect, useState } from "react";
import { HelperContext } from "../../../store/helperStore";
import GetTestCard from "./getTestCard";

// -----------------------audio - test tile----------------

export const AProcessingEff = ({ data }) => {
  const { helperC, dispatchHelper } = HelperContext();
  const [instVisible, setInstVisible] = useState();

  useEffect(() => {
    if (helperC.testType === "DEMO") {
      if (helperC.testSection === data.name) setInstVisible(true);
    }
  }, []);

  return (
    <Fragment>
      {data.tests && (
        <>
          <h2>{data.name}</h2>
          <GetTestCard
            instVisible={instVisible}
            handleInstVisible={(data) => {
              setInstVisible(data);
            }}
            testData={data.tests}
          />
        </>
      )}
    </Fragment>
  );
};
export const AAcqKnow = ({ data }) => {
  const [instVisible, setInstVisible] = useState();
  const { helperC, dispatchHelper } = HelperContext();
  useEffect(() => {
    if (helperC.testType === "DEMO") {
      if (helperC.testSection === data.name) setInstVisible(true);
    }
  }, []);
  return (
    <Fragment>
      {data.tests && (
        <>
          <h2>{data.name}</h2>
          <GetTestCard
            instVisible={instVisible}
            handleInstVisible={(data) => {
              setInstVisible(data);
            }}
            sectionName={data.name}
            testData={data.tests}
          />
        </>
      )}
    </Fragment>
  );
};
export const APerPro = ({ data }) => {
  const [instVisible, setInstVisible] = useState();
  const { helperC, dispatchHelper } = HelperContext();

  useEffect(() => {
    if (helperC.testType === "DEMO") {
      if (helperC.testSection === data.name) setInstVisible(true);
    }
  }, []);
  return (
    <Fragment>
      {data.tests && (
        <>
          <h2>{data.name}</h2>
          <GetTestCard
            instVisible={instVisible}
            handleInstVisible={(data) => {
              setInstVisible(data);
            }}
            testData={data.tests}
          />
        </>
      )}
    </Fragment>
  );
};
export const AMemPro = ({ data }) => {
  const [instVisible, setInstVisible] = useState();
  const { helperC, dispatchHelper } = HelperContext();

  useEffect(() => {
    if (helperC.testType === "DEMO") {
      if (helperC.testSection === data.name) setInstVisible(true);
    }
  }, []);
  return (
    <Fragment>
      {data.tests && (
        <>
          <h2>{data.name}</h2>
          <GetTestCard
            instVisible={instVisible}
            handleInstVisible={(data) => {
              setInstVisible(data);
            }}
            testData={data.tests}
          />
        </>
      )}
    </Fragment>
  );
};

// -----------------------non-audio - test tile-------------
export const NAResAbl = ({ data }) => {
  const [instVisible, setInstVisible] = useState();
  const { helperC, dispatchHelper } = HelperContext();

  useEffect(() => {
    if (helperC.testType === "DEMO") {
      if (helperC.testSection === data.name) setInstVisible(true);
    }
  }, []);
  return (
    <Fragment>
      {data.tests && (
        <>
          <h2>{data.name}</h2>
          <GetTestCard
            instVisible={instVisible}
            handleInstVisible={(data) => {
              setInstVisible(data);
            }}
            testData={data.tests}
          />
        </>
      )}
    </Fragment>
  );
};
export const NAProcessingEff = ({ data }) => {
  const [instVisible, setInstVisible] = useState();
  const { helperC, dispatchHelper } = HelperContext();

  useEffect(() => {
    if (helperC.testType === "DEMO") {
      if (helperC.testSection === data.name) setInstVisible(true);
    }
  }, []);
  return (
    <Fragment>
      {data.tests && (
        <>
          <h2>{data.name}</h2>
          <GetTestCard
            instVisible={instVisible}
            handleInstVisible={(data) => {
              setInstVisible(data);
            }}
            testData={data.tests}
          />
        </>
      )}
    </Fragment>
  );
};
export const NAAcqKnow = ({ data }) => {
  const [instVisible, setInstVisible] = useState();
  const { helperC, dispatchHelper } = HelperContext();

  useEffect(() => {
    if (helperC.testType === "DEMO") {
      if (helperC.testSection === data.name) setInstVisible(true);
    }
  }, []);
  return (
    <Fragment>
      {data.tests && (
        <>
          <h2>{data.name}</h2>
          <GetTestCard
            instVisible={instVisible}
            handleInstVisible={(data) => {
              setInstVisible(data);
            }}
            testData={data.tests}
          />
        </>
      )}
    </Fragment>
  );
};
export const NAPerPro = ({ data }) => {
  const [instVisible, setInstVisible] = useState();
  const { helperC, dispatchHelper } = HelperContext();

  useEffect(() => {
    if (helperC.testType === "DEMO") {
      if (helperC.testSection === data.name) setInstVisible(true);
    }
  }, []);
  return (
    <Fragment>
      {data.tests && (
        <>
          <h2>{data.name}</h2>
          <GetTestCard
            instVisible={instVisible}
            handleInstVisible={(data) => {
              setInstVisible(data);
            }}
            testData={data.tests}
          />
        </>
      )}
    </Fragment>
  );
};
export const NAMemPro = ({ data }) => {
  const [instVisible, setInstVisible] = useState();
  const { helperC, dispatchHelper } = HelperContext();

  useEffect(() => {
    if (helperC.testType === "DEMO") {
      if (helperC.testSection === data.name) setInstVisible(true);
    }
  }, []);
  return (
    <Fragment>
      {data.tests && (
        <>
          <h2>{data.name}</h2>
          <GetTestCard
            instVisible={instVisible}
            handleInstVisible={(data) => {
              setInstVisible(data);
            }}
            testData={data.tests}
          />
        </>
      )}
    </Fragment>
  );
};
